var articleinfo = [
    
    //     {
    //     id: 14,
    //     title: "What is the cost of removing coal generation?",
    //     date: "June 2024, Register to read",
    //     description: "We have calculated the average cost of generation under a plausible scenario as coal is replaced by renewable energy.... ",
    //     coverImg: "solarfarm.jpg",
    //     page: "Premarticle8"
    // }, 
    {
        id: 21,
        title: "WEM Monthly Review",
        date: "Register to read",
        description: "Insights into the Western Australian Wholesale Electricity Market.",
        coverImg: "FrontPage.png",
        page: "Premarticle15"
    },  
    {
        id: 21,
        title: "Report finds returns are too high by almost $1 billion",
        date: "February 2026",
        description: "Our report for Energy Consumers Australia's submission to the Australian Energy Regulator's review of the rate of return is now available. ",
        coverImg: "pexels-don-cockman.jpg",
        page: "Article13"
    }, 
    {
        id: 22,
        title: "Home energy calculator",
        date: "December 2025",
        description: "Our home energy calculator helps you see what your electricity costs would be if you added solar panels, a battery or an electric vehicle.",
        coverImg: "calculator.jpg",
        page: "Article12"
    }, 
    {
        id: 20,
        title: "The challenges with estimating returns for renewable energy projects",
        date: "July 2025, Register to read",
        description: "We explain why the returns from some renewable energy projects are less than might be expected ...",
        coverImg: "solarcells.jpg",
        page: "Premarticle16"
    }, 
    
    {
        id: 19,
        title: "How much would nuclear energy add to the cost of generation?",
        date: "September 2024, Register to read",
        description: "We have costed the transition to a low-emissions electricity grid under alternative scenarios ...  ",
        coverImg: "lamp.jpg",
        page: "Premarticle13"
    },    

    {
        id: 18,
        title: "What is driving price volatility in the WEM?",
        date: "August 2024, Register to read",
        description: "The new market design has increased volatility, but a change in bidding behaviour has also increased volatility ...  ",
        coverImg: "MagdaEhlers.jpg",
        page: "Premarticle12"
    },     
    
    {
        id: 17,
        title: "Emission reductions and reliability at risk under current market settings",
        date: "June 2024, Register to read",
        description: "If current trends in the market continue, carbon emissions in the WEM will remain at current levels for an extended period and reliability may not be maintained ...  ",
        coverImg: "solarfarm.jpg",
        page: "Premarticle11"
    }, 

    //{
    //    id: 7,
    //    title: "Carbon emissions tracker",
    //    date: "Updated April 2025",
    //    description: "We track carbon emissions from the WEM ...",
    //    coverImg: "Carbonhistory.jpeg",
    //    page: "Article7"
   // },

    {
        id: 16,
        title: "Gas generation doesn't need to increase",
        date: "May 2024, Register to read",
        description: "There is a plausible scenario where the exit of coal generation doesn't result in an increase in gas generation ... ",
        coverImg: "lighter.jpg",
        page: "Premarticle10"
    }, 


    {
        id: 15,
        title: "Thermal generators benefiting from higher prices",
        date: "March 2024, Register to read",
        description: "A substantial increase in the price of energy in the WEM has boosted the wholesale value of coal and gas generation ... ",
        coverImg: "gasburner.jpg",
        page: "Premarticle9"
    }, 
    
    {
        id: 10,
        title: "Why is the new market producing volatile prices?",
        date: "March 2024, Register to read",
        description: "Balancing prices have become more volatile since the new market commenced in October ... ",
        coverImg: "lighteg.jpg",
        page: "Premarticle6"
    }, 
    
    {
        id: 13,
        title: "How did the market cope this summer?",
        date: "March 2024, Register to read",
        description: "We review how the market coped with the hot summer...",
        coverImg: "transmissioneg.jpg",
        page: "Premarticle5"
    },
    

    {
        id: 12,
        title: "Blackout risk heading into the summer peak",
        date: "January 2024, Register to read",
        description: "We consider the likelihood of a blackout over the 2023/24 summer ...",
        coverImg: "blackout.jpg",
        page: "Premarticle1"
    },

    {
        id: 5,
        title: "Our summary of the Gas Statement of Opportunities",
        date: "December 2023",
        description: "We summarise AEMO's GSOO ...",
        coverImg: "gas.jpg",
        page: "Article4"
    },

    {
        id: 3,
        title: "Coal generation offer prices ",
        date: "December 2023",
        description: "The protracted issues over coal supplies to generators in the WEM has led to speculation about the marginal cost of coal generation. ...",
        coverImg: "coal.jpeg",
        page: "Article5"
    },


    {
        id: 11,
        title: "Our views on operational demand",
        date: "December 2023, Register to read",
        description: "We review AEMO's forecast of a substantial increase in operational demand ... ",
        coverImg: "sunset.jpg",
        page: "Article11"
    }, 
   

    
    // {
    //     id: 2,
    //     title: "Synergy standard products",
    //     date: "Updated December 2023, Premium",
    //     description: "We review Synergy’s standard products prices in order to understand the assumptions that underpin the forecasts... ",
    //     coverImg: "windmills2.jpg",
    //     page: "Premarticle4"
    // },
    

    {
        id: 9,
        title: "Our submission to the review of the capacity mechanism",
        date: "May 2023",
        description: "Our recommendation is for Energy Policy WA to adopt an ex-ante design for both the peak and flexible IRCR mechanisms...",
        coverImg: "panels.jpg",
        page: "Article9"
    },
    
    {
        id: 8,
        title: "Synergy's renewable strategy",
        date: "March 2023",
        description: "Synergy's renewable energy statement is an interesting development because it is suggesting the state government is not prioritising the development of an energy market in Western Australia with private sector investment ...",
        coverImg: "bladerow.jpg",
        page: "Article8"
    },
    {
        id: 1,
        title: "Policy priorities for the WEM",
        date: "February 2023, Register to read",
        description: "Our commentary on the ERA’s report on the effectiveness of the WEM ...",
        coverImg: "elec.jpg",
        page: "Premarticle7"
    },
 
    {
        id: 4,
        title: "A comment on the renewable energy strategy",
        date: "February 2023",
        description: "Electricity generation for the WEM accounts for around 10m tCO2e, which compares to total Western Australian emissions of over 91m tCO2e.... ",        
        coverImg: "windmills.jpg",
        page: "Article1"
    },




]

export default articleinfo